/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type employee_selfservice_PersonalDataOpenRequest = {
    /**
     * ID is the change request id (used by withdraw).
     */
    id: string;
    /**
     * Section is the part of the personal data the request changes.
     */
    section: employee_selfservice_PersonalDataOpenRequest.section;
    /**
     * Status is pending (awaiting review), approved (being applied) or manual
     * (the office applies it by hand).
     */
    status: employee_selfservice_PersonalDataOpenRequest.status;
    /**
     * SubmittedAt is when the employee filed the request.
     */
    submittedAt: string;
};
export namespace employee_selfservice_PersonalDataOpenRequest {
    /**
     * Section is the part of the personal data the request changes.
     */
    export enum section {
        ADDRESS = 'address',
        PHONE = 'phone',
        EMERGENCY_CONTACTS = 'emergency_contacts',
    }
    /**
     * Status is pending (awaiting review), approved (being applied) or manual
     * (the office applies it by hand).
     */
    export enum status {
        PENDING = 'pending',
        APPROVED = 'approved',
        MANUAL = 'manual',
    }
}

